import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Simple session ID using crypto.randomUUID (built-in browser API)
const getSessionId = () => {
  let sid = sessionStorage.getItem('cop31_session_id');
  if (!sid) {
    sid = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('cop31_session_id', sid);
  }
  return sid;
};

const VisitorTracker = () => {
  const location = useLocation();
  const prevUrl = useRef(null);
  const entryTime = useRef(Date.now());

  useEffect(() => {
    try {
      const sessionId = getSessionId();
      const currentUrl = location.pathname;
      const duration = prevUrl.current ? Math.round((Date.now() - entryTime.current) / 1000) : 0;

      axios.post(`${API}/ultra-admin/track-visit`, {
        url: currentUrl,
        prev_url: prevUrl.current || currentUrl,
        session_id: sessionId,
        referrer: document.referrer,
        duration,
      }).catch(() => {});

      prevUrl.current = currentUrl;
      entryTime.current = Date.now();
    } catch (_) {
      // Silently fail — tracking must never break the app
    }
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
